import clienteAxios from "../config/clienteAxios";

export const postConsultaCV = async (data) => {
    const resp = await clienteAxios.post('/contact/createCv', 
        data,
        {headers: {
            'Content-Type': 'multipart/form-data'
        }}
    );
    return resp;
};

/*const {data} = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_BACKEND_URL}/contact/createCv`,
    data: data,
    headers: {
    'Content-Type': 'multipart/form-data'}
})*/